import { render, staticRenderFns } from "./JoszakiDropdownOld.vue?vue&type=template&id=ea6491e8"
import script from "./JoszakiDropdownOld.vue?vue&type=script&lang=js"
export * from "./JoszakiDropdownOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports